import {List} from "immutable";
import Env from "./env";
import Reader from "./shift-reader";
import  * as _ from "ramda";
import TokenExpander from "./token-expander.js";
import BindingMap from "./binding-map.js";
import Term, {isEOF, isBindingIdentifier, isFunctionDeclaration, isFunctionExpression, isFunctionTerm, isFunctionWithName, isSyntaxDeclaration, isSyntaxrecDeclaration, isVariableDeclaration, isVariableDeclarationStatement, isImport, isExport} from "./terms";
import loadSyntax from "./load-syntax";
class Module_388 {
  constructor(moduleSpecifier_390, importEntries_391, exportEntries_392, body_393) {
    this.moduleSpecifier = moduleSpecifier_390;
    this.importEntries = importEntries_391;
    this.exportEntries = exportEntries_392;
    this.body = body_393;
  }
  visit(context_394) {
    this.exportEntries.forEach(ex_395 => {
      if (isSyntaxDeclaration(ex_395.declaration) || isSyntaxrecDeclaration(ex_395.declaration)) {
        ex_395.declaration.declarators.forEach(loadSyntax(_.__, context_394, context_394.store));
      }
    });
    return context_394.store;
  }
}
const pragmaRegep_389 = /^\s*#\w*/;
export class Modules {
  constructor() {
    this.loadedModules = new Map;
  }
  load(modulePath_396, context_397) {
    let path_398 = context_397.moduleResolver(modulePath_396, context_397.cwd);
    if (!this.loadedModules.has(path_398)) {
      let modStr = context_397.moduleLoader(path_398);
      if (!pragmaRegep_389.test(modStr)) {
        this.loadedModules.set(path_398, new Module_388(path_398, List(), List(), List()));
      } else {
        let reader = new Reader(modStr);
        let stxl = reader.read().slice(3);
        let tokenExpander = new TokenExpander(_.merge(context_397, {env: new Env, store: new Env, bindings: new BindingMap}));
        let terms = tokenExpander.expand(stxl);
        let importEntries = [];
        let exportEntries = [];
        terms.forEach(t_399 => {
          _.cond([[isImport, t_400 => importEntries.push(t_400)], [isExport, t_401 => exportEntries.push(t_401)]])(t_399);
        });
        this.loadedModules.set(path_398, new Module_388(path_398, List(importEntries), List(exportEntries), terms));
      }
    }
    return this.loadedModules.get(path_398);
  }
}
